/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartResponseDto
 */
export interface PartResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PartResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PartResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof PartResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartResponseDto
     */
    manufacturer: string;
    /**
     * 
     * @type {string}
     * @memberof PartResponseDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PartResponseDto
     */
    properties?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof PartResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PartResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the PartResponseDto interface.
 */
export function instanceOfPartResponseDto(value: object): value is PartResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('manufacturer' in value) || value['manufacturer'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PartResponseDtoFromJSON(json: any): PartResponseDto {
    return PartResponseDtoFromJSONTyped(json, false);
}

export function PartResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'manufacturer': json['manufacturer'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function PartResponseDtoToJSON(json: any): PartResponseDto {
    return PartResponseDtoToJSONTyped(json, false);
}

export function PartResponseDtoToJSONTyped(value?: PartResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'manufacturer': value['manufacturer'],
        'serialNumber': value['serialNumber'],
        'properties': value['properties'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

